import React, { useState } from 'react';
import { List, ListItem, ListItemAvatar, Avatar, ListItemText, IconButton, Drawer, Typography, Button } from '@mui/material';
import { Chat, Close, ExpandMore, ExpandLess } from '@mui/icons-material';

export default function ChatList() {
    const [openList, setOpenList] = useState(false);  // 控制右下角悬浮聊天列表开关
    const [openChatWindow, setOpenChatWindow] = useState(false);  // 控制聊天窗口开关
    const [activeChat, setActiveChat] = useState(null);

    const chats = [
        {
            avatar: 'https://via.placeholder.com/40',
            username: '张三',
            lastMessage: '你好，我有个问题想请教。',
            chatType: '求职',
        },
        {
            avatar: 'https://via.placeholder.com/40',
            username: '李四',
            lastMessage: '我们明天的会议时间是几点？',
            chatType: '招聘',
        },
        {
            avatar: 'https://via.placeholder.com/40',
            username: '王五',
            lastMessage: '谢谢你的帮助！',
            chatType: '普通聊天',
        },
    ];

    // 打开或关闭聊天列表
    const toggleChatList = () => {
        setOpenList(!openList);
    };

    // 打开聊天窗口
    const handleChatClick = (chat) => {
        setActiveChat(chat);
        setOpenChatWindow(true);
    };

    // 关闭聊天窗口
    const handleCloseChatWindow = () => {
        setOpenChatWindow(false);
    };

    return (
        <div>
            {/* 右下角悬浮按钮 */}
            <IconButton
                onClick={toggleChatList}
                style={{
                    position: 'fixed',
                    zIndex: 1000, // 确保按钮在最前
                    bottom: 60,
                    right: 20,
                    backgroundColor: '#007bff',
                    color: '#fff',
                    borderRadius: '10%', // 使按钮变为圆形
                    padding: '10px', // 调整按钮内边距
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // 添加阴影效果
                }}
            >
                {openList ? <ExpandMore /> : <ExpandLess />}
                <Typography variant="caption" sx={{ marginLeft: '5px' }}>消息</Typography>
            </IconButton>

            {/* 右侧悬浮聊天列表 */}
            <Drawer
                anchor="right"
                open={openList}
                onClose={toggleChatList}
                PaperProps={{
                    style: { width: 300, height: '90%', top: '10%', padding: '10px' }
                }}
            >
                <Typography variant="h6" align="center" gutterBottom>
                    聊天列表
                </Typography>
                <List>
                    {chats.map((chat, index) => (
                        <ListItem button key={index} onClick={() => handleChatClick(chat)}>
                            <ListItemAvatar>
                                <Avatar src={chat.avatar} />
                            </ListItemAvatar>
                            <ListItemText primary={chat.username} secondary={chat.chatType} />
                        </ListItem>
                    ))}
                </List>
            </Drawer>

            {/* 聊天窗口 */}
            <Drawer
                anchor="right"
                open={openChatWindow}
                onClose={handleCloseChatWindow}
                PaperProps={{
                    style: { width: 400, height: '100%', padding: '10px' }
                }}
            >
                {activeChat && (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="h6">{activeChat.username} - {activeChat.chatType}</Typography>
                            <IconButton onClick={handleCloseChatWindow}>
                                <Close />
                            </IconButton>
                        </div>
                        {/* 这里可以是聊天内容 */}
                        <div style={{ height: 'calc(100% - 150px)', overflowY: 'auto', marginTop: '20px' }}>
                            <p>{activeChat.lastMessage}</p>
                        </div>
                        {/* 发送消息输入框 */}
                        <div style={{ position: 'absolute', bottom: 10, width: 'calc(100% - 20px)', display: 'flex' }}>
                            <input type="text" placeholder="输入消息..." style={{ flexGrow: 1, padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }} />
                            <Button variant="contained" color="primary" style={{ marginLeft: '10px' }}>发送</Button>
                        </div>
                    </div>
                )}
            </Drawer>
        </div >
    );
}